import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import {
  gqlClient,
  gqlHeader,
  runGqlQueryV2,
} from "../../../../../../graphql/client";
import { ServiceProviderR } from "../../../routes";

/**
 * URL 上の tenantId を元に製品情報を取得し、
 * kintone 連携機能が有効化されているかを確認する。
 * 有効出ない場合はデータ連携トップページにリダイレクトする。
 */
export const KintoneExportOrgProductAssertion: React.FC = () => {
  const { tenantId } = useParams<{ tenantId: string }>();
  const history = useHistory();

  React.useEffect(() => {
    const checkOrgProduct = async () => {
      const res = await runGqlQueryV2(() =>
        gqlClient.allOrgProductsByOrgId({ orgId: tenantId }, gqlHeader("q")),
      );
      if (res.error) {
        toast.error("製品情報の取得に失敗しました。");
        return;
      }

      const isKintoneExportEnabled =
        res.data!.allOrgProductsByOrgId.filter(
          ({ productCode, plan }) =>
            productCode === "KintoneExport" && plan !== "NotSet",
        ).length > 0;

      if (isKintoneExportEnabled) {
        return;
      }
      history.replace(ServiceProviderR.DataTransferTop.link({ tenantId }));
    };
    checkOrgProduct();
  }, [tenantId, history]);

  return null;
};
